import * as React from 'react';
import { style } from '@project/store/Legend';

const HEATMAP_DEFAULT_PROPS = {
  radius: 10,
  blur: 10,
  gradient: ['#00f', '#0ff', '#0f0', '#ff0', '#f00'],
};

export interface HeatmapItemProps {
  style: style.LayerHeatmapStyle;
  iconStyle?: React.CSSProperties;
}

export const HeatMapStyleLegend: React.FC<HeatmapItemProps> = ({
  style,
  iconStyle = {},
}) => {
  const gradient = style?.gradient || HEATMAP_DEFAULT_PROPS.gradient;

  return (
    <>
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            display: 'inline-block',
            marginRight: '5px',
            borderRadius: '50%',
            width: '24px',
            height: '24px',
            background: `radial-gradient(${gradient[4]} 20%, ${gradient[3]}, ${gradient[2]}, ${gradient[1]}, ${gradient[0]})`,
            boxShadow: `0 0 10px ${gradient[1]}`,
            ...iconStyle,
          }}
        />

        <div>Тепловые стили</div>
      </span>
    </>
  );
};
